import React, { Suspense } from 'react';
import { AxisFilter } from "../../components/Filter/AxisFilter";

require("../../utils/Settings");
require("../../utils/Paths");
require("../../utils/Globals");
require("../../utils/Languages");
require("../../utils/Search-Params");
require("../../modules/cookie/cookie");

function App() {
    return (
        <Suspense fallback={<div></div>}>
            <div className="main" style={{ paddingBottom: "30px" }}>
                <AxisFilter />
            </div> 
        </Suspense>
    );
}

export default App;